<script setup>
import { ref, onMounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useConfirm } from "primevue/useconfirm"
import axios from "axios"
import { FilterMatchMode } from 'primevue/api'
import login1img from '../assets/images/login1.svg'
import login2img from '../assets/images/login2.svg'
import login3img from '../assets/images/login3.svg'
import login4img from '../assets/images/login4.svg'

const loader = ref(false)
const toast = useToast()
const confirm = useConfirm()

const country_code = ref('+41')
const country_codes = ref([
    {"code": "+41", "value": "+41"},
    {"code": "+49", "value": "+49"}
])
const activeTabIndex = ref(0)
const filter_templates = ref({ 'global': { value: '', matchMode: FilterMatchMode.CONTAINS } })
const filter_candidates = ref({ 'global': { value: '', matchMode: FilterMatchMode.CONTAINS } })
const filter_jobs = ref({ 'global': { value: '', matchMode: FilterMatchMode.CONTAINS } })
const filter_users = ref({ 'global': { value: '', matchMode: FilterMatchMode.CONTAINS } })

const edit_job_slider = ref(false)
const edit_job_marketing_slider = ref(false)
const test_email_dialog = ref(false)
const create_job_dialog = ref(false)
const view_candidate_slider = ref(false)
const pdf_viewer = ref(false)
const templates = ref({})
const users = ref([])
const test_email = ref()

const token = ref('')
const workflow_id = ref('')
const random_image_number = ref(1)
const login_image = ref(null)
const get_login_image = () => {
    random_image_number.value = Math.floor(Math.random() * 4) + 1
    if (random_image_number.value == 1) login_image.value = login1img
    if (random_image_number.value == 2) login_image.value = login2img
    if (random_image_number.value == 3) login_image.value = login3img
    if (random_image_number.value == 4) login_image.value = login4img
}

const yes_no = ref([
    { label: 'Ja', value: 'yes' },
    { label: 'Nein', value: 'no' }
])

const role = ref('')
const roles = ref([
    { label: 'Admin', value: 'Admin' },
    { label: 'Benutzer', value: 'Benutzer' }
])

onMounted(() =>{
    get_login_image()
    token.value = localStorage.getItem('token')
    workflow_id.value = localStorage.getItem('workflow_id')
    if (token.value) {
        console.log("verify_token 1", token.value, workflow_id.value)
        verify_token()
    }
})

const login = ref(false)
const mobile = ref('')
const token_login = ref(false)
const login_error = ref(false)
const logout_message = ref(false)
const admin_login = () => {
    console.log(mobile.value)
    loader.value = true
    logout_message.value = false
    let mobile_number = mobile.value
    mobile_number = mobile_number.replace(/ /g, '')
    mobile_number = mobile_number.replace('0', country_code.value)
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/send-2fa', {number: mobile_number, partner: "SNAPPYJOBSMB"})
    .then(response => {
        console.log(response.data)
        if (response.data.message == 'error') {
            toast.add({severity: 'error', summary: 'Fehler', detail: 'Es ist ein Fehler aufgetreten', life: 3000})
            login_error.value = true
            loader.value = false
        }
        if (response.data.message == 'success') {
            toast.add({severity: 'success', summary: 'SMS gesendet', detail: 'Die SMS wurde erfolgreich gesendet', life: 3000})
            token_login.value = true
            login_error.value = false
            workflow_id.value = response.data.workflow_id
            localStorage.setItem('workflow_id', workflow_id.value)
            loader.value = false
        }
    })
}

const sms_error = ref(false)
const sms_token = ref('')
const user_name = ref('')
const user_email = ref('')
const user_role = ref('')
const verify_sms_token = () => {
    loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-sms-token', {code: sms_token.value, workflow_id: workflow_id.value})
    .then((response) => {
        console.log(response.data)
        if (response.data.message == 'success') {
            login.value = true
            token.value = response.data.token
            localStorage.setItem('token', token.value)
            user_name.value = response.data.user.name
            user_email.value = response.data.user.email
            user_role.value = response.data.user.role
            sms_error.value = false
            get_jobs()
            get_templates()
            get_candidates()
            get_users()
            loader.value = false
        } else {
            sms_error.value = true
            loader.value = false
        }
    })
}

const verification_loader = ref(false)
const verify_token = () => {
    verification_loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/partner/login/verify-token', {workflow_id: workflow_id.value, token: token.value})
    .then((response) => {
        console.log("verify_token 2", response.data)
        if (response.data.message == 'success') {
            user_name.value = response.data.user.name
            user_email.value = response.data.user.email
            user_role.value = response.data.user.role
            get_jobs()
            get_templates()
            get_candidates()
            get_users()
            login.value = true
            verification_loader.value = false
        } else {
            admin_logout()
            verification_loader.value = false
        }
    })
}

const admin_logout = () => {
    token.value = ''
    workflow_id.value = ''
    localStorage.removeItem('token')
    localStorage.removeItem('workflow_id')
    login.value = false
    token_login.value = false
    login_error.value = false
    sms_error.value = false
    logout_message.value = true
}

const edit_job = (jobdata) => {
    console.log(jobdata)
    job.value = jobdata
    edit_job_slider.value = true
}

const edit_job_marketing = (jobdata) => {
    console.log(jobdata)
    job.value = jobdata
    edit_job_marketing_slider.value = true
}

const view_candidate = (event) => {
    console.log(event)
    candidate.value = event.data
    view_candidate_slider.value = true
}

const pdf_url = ref('')
const open_pdf = (url) => {
    pdf_viewer.value = true
    pdf_url.value = url
}

const open_url = (url) => {
    window.open(url, '_blank')
} 

const swiss_date_time = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
}

const swiss_date = (date) => {
    return new Date(date).toLocaleDateString('de-CH', { year: 'numeric', month: '2-digit', day: '2-digit' })
}

const edit_users = ref([])
const on_row_user_save = (event) => {
    let { newData, index } = event
    newData["mobile"] = newData["mobile"].replace(/ /g, '')
    users.value[index] = newData
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/save-user', newData)
    .then((response) => {
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Benutzer wurde erfolgreich gespeichert', life: 3000 })
    })
}

const create_user = (user) => {
    loader.value = true
    user.mobile = user.mobile.replace(/ /g, '')
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/create-user', user)
    .then((response) => {
        if (response.data.message == 'success'){
            get_users()
            toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Benutzer wurde erfolgreich erstellt', life: 3000 })
            loader.value = false
            create_user_dialog.value = false
        } else {
            toast.add({ severity: 'error', summary: 'Fehler', detail: 'Benutzer konnte nicht angelegt werden (Handynummer oder E-Mail existiert bereits)', life: 3000 })
            loader.value = false
        }
    })
}

const job = ref({})
const jobs = ref([])

const get_jobs = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/get-jobs')
    .then((response) => {
        jobs.value = response.data
    })
}

const get_candidates = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/get-candidates')
    .then((response) => {
        console.log("candidates", response.data)
        candidates.value = response.data
    })
}

const get_users = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/get-users')
    .then((response) => {
        console.log("users", response.data)
        users.value = response.data
    })
}

const create_user_dialog = ref(false)
const new_user = ref({
    "name": "",
    "mobile": "",
    "email": "",
    "role": "Benutzer"
})

const get_templates = () => {
    axios.get(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/get-templates')
    .then((response) => {
        templates.value = response.data
    })
}

const save_templates = () => {
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/save-templates', templates.value)
    .then((response) => {
        template_edits.value = 0
        get_templates()
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Vorlagen wurden erfolgreich gespeichert', life: 3000 })
    })
}

const save_template = () => {
    templates.value[template_index.value] = template.value
    template_edits.value++
    edit_template_dialog.value = false
}

const create_template = () => {
    templates.value.push({
        "id": "neue_vorlage",
        "name": "Neue Vorlage",
        "subject": "Neue Vorlage",
        "content": "<p>Neue Vorlage</p>"
    })
    template_edits.value++
}

const template = ref({})
const template_edits = ref(0)
const template_index = ref(null)
const edit_template_dialog = ref(false)
const edit_template = (e) => {
    console.log(e)
    template_index.value = e.index
    edit_template_dialog.value = true
    template.value = e.data
}

const delete_template = (e) => {
    console.log(e)
    templates.value.splice(e.index, 1)
    template_edits.value++
}

const job_types = ref([
    { label: 'Festanstellung', value: 'Festanstellung' },
    { label: 'Temporär', value: 'Temporär' },
    { label: 'Teilzeit', value: 'Teilzeit' },
    { label: 'Vollzeit', value: 'Vollzeit' }
])

const job_description_types = ref([
    { label: '3-Punkte', value: '3-dots' },
    { label: '2-Punkte', value: '2-dots' },
    { label: '1-Punkt', value: '1-dot' },
    { label: 'Sprache', value: 'language' },
    { label: 'Ausbildung', value: 'education' },
    { label: 'Erfahrung', value: 'expirience' }
])

const get_job_description_type = (type) => {
    let job_description_type = job_description_types.value.find(x => x.value == type)
    if (job_description_type == undefined) {
        return ''
    } else {
        return job_description_type.label
    }
}

const edit_job_description_save = (event) => {
    console.log(event)
    if (event.value != event.newValue) {
        job.value.job_description[event.index][event.field] = event.newValue
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Beschreibung wurde erfolgreich gespeichert', life: 3000 })
    }
}

const edit_job_requirements_save = (event) => {
    console.log(event)
    if (event.value != event.newValue) {
        job.value.job_requirements[event.index][event.field] = event.newValue
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Beschreibung wurde erfolgreich gespeichert', life: 3000 })
    }
}

const delete_job_description = (slotProps) => {
    confirm.require({
        message: 'Möchten Sie diese Beschreibung wirklich löschen?',
        header: 'Beschreibung löschen',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, löschen',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            job.value.job_description.splice(slotProps.index, 1)
            toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Beschreibung wurde erfolgreich gelöscht', life: 3000 })
        }
    })
}

const delete_job_requirements = (slotProps) => {
    confirm.require({
        message: 'Möchten Sie diese Anforderung wirklich löschen?',
        header: 'Anforderung löschen',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, löschen',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            job.value.job_requirements.splice(slotProps.index, 1)
            toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Anforderung wurde erfolgreich gelöscht', life: 3000 })
        }
    })
}

const candidate = ref({})
const candidates = ref([])

const new_job = ref({
    "job_id": "",
    "job_title": "",
    "postal_code": "",
    "city": "",
    "job_type": "",
    "job_capacity": "",
    "job_description": [],
    "job_requirements": [],
    "job_contact_name": "",
    "job_contact_role": "",
    "job_contact_email": "",
    "job_url": "",
    "job_runtime_start": "",
    "job_runtime_end": "",
    "job_status": "inactive"
})

const job_statuses = ref([
    { label: 'Aktiv', value: 'active' },
    { label: 'Inaktiv', value: 'inactive' }
])

const create_job = () => {
    create_job_dialog.value = true
}
const save_new_job = () => {
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/create-job', new_job.value)
    .then((response) => {
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Stelle wurde erfolgreich erstellt', life: 3000 })
        get_jobs()
        create_job_dialog.value = false
    })
    create_job_dialog.value = false
}

const save_job = () => {
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/save-job', job.value)
    .then((response) => {
        toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Stelle wurde erfolgreich gespeichert', life: 3000 })
        get_jobs()
        edit_job_slider.value = false
    })
}

const delete_job = (slotProps) => {
    confirm.require({
        message: 'Möchten Sie diese Stelle wirklich löschen?',
        header: 'Stelle löschen',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, löschen',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/delete-job', {job_id: slotProps.job_id})
            .then((response) => {
                toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Stelle wurde erfolgreich gelöscht', life: 3000 })
                get_jobs()
            })
        }
    })
}

const copy_to_clipboard = (value) => {
    navigator.clipboard.writeText(value)
    toast.add({severity:'success', summary: 'Erfolgreich', detail: 'In Zwischenablage kopiert', life: 3000});
}

const send_test_email = () => {
    loader.value = true
    axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/send-test-email', {email: test_email.value, template: test_email_template.value})
    .then((response) => {
        if (response.data.message == 'success') {
            toast.add({ severity: 'success', summary: 'Erfolg', detail: 'Test-E-Mail wurde erfolgreich versendet', life: 3000 })
            loader.value = false
            test_email_dialog.value = false
        } else {
            toast.add({ severity: 'error', summary: 'Fehler', detail: 'Test-E-Mail konnte nicht versendet werden', life: 3000 })
            loader.value = false
        }
    })
}

const test_email_template = ref('')
const send_test_email_input = (e) => {
    test_email.value = user_email.value
    test_email_dialog.value = true
    test_email_template.value = e.data.id
}

const candidate_flow = ref(null)
const candidate_email_content = ref('')
const candidate_email_subject = ref('')
const dialog_send_candidate_email = ref(false)
const email_preview = ref(true)

const send_candidate_email = (flow) => {
    if (flow == 'not_interesting'){
        axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/convert-mail-content', {template_id: 'absage1', candidate_id: candidate.value.workflow_id})
        .then((response) => {
            console.log(response.data)
            if (response.data.message == 'success') {
                candidate_email_content.value = response.data.content
                candidate_email_subject.value = response.data.subject
                dialog_send_candidate_email.value = true
            }
        })
    }
}

const send_candidate_email_with_template = () => {
    confirm.require({
        message: 'Möchten Sie diese E-Mail wirklich versenden?',
        header: 'E-Mail an Kandidat senden?',
        rejectLabel: 'Nein',
        acceptLabel: 'Ja, senden',
        acceptClass: 'p-button-danger',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            loader.value = true
            axios.post(process.env.VUE_APP_NEURAXIS_API_MAIN + '/migrosbank/send-candidate-email', {content: candidate_email_content.value, subject: candidate_email_subject.value, candidate_id: candidate.value.workflow_id})
            .then((response) => {
                if (response.data.message == 'success') {
                    toast.add({ severity: 'success', summary: 'Erfolg', detail: 'E-Mail wurde erfolgreich versendet', life: 3000 })
                    loader.value = false
                    dialog_send_candidate_email.value = false
                    view_candidate_slider.value = false
                    get_candidates()
                } else {
                    toast.add({ severity: 'error', summary: 'Fehler', detail: 'E-Mail konnte nicht versendet werden', life: 3000 })
                    loader.value = false
                }
            })
        }
    })
}

</script>

<style lang="scss" scoped>
    @import '@/core/assets/primevue/primeflex.scss';
</style>

<style>
.mb_url {
    color: #144B3C;
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
}
.mb_green {
    background-color: #144B3C;
    color: #FFF;
    border-color: #FFF;
}

.mb_green_border {
    border-color: #144B3C;
}

.mb_pink {
    background-color: #E34055;
    color: #FFF;
    border-color: #E34055;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
    color: #144B3C;
    border-color: #144B3C;
}

.p-tabview .p-tabview-nav .p-tabview-ink-bar {
    background-color: #144B3C;
}
</style>

<template>
    <Toast />
    <ConfirmDialog />
    <ProgressSpinner v-if="loader == true" style="position: fixed; z-index: 999; overflow: show; margin: auto; top: 0; left: 0; bottom: 0; right: 0; width: 50px; height: 50px;" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" aria-label="Loading..." />
    <div v-if="!verification_loader" class="flex justify-content-center mt-6">
        <div class="surface-card p-4 shadow-3 border-round" style="width: 1200px" >
            <div class="flex justify-content-between">
                <img src="../assets/images/snappy_jobs.svg" width="300" />
            </div>
            <div class="flex justify-content-between">
                <h1 class="font-bold pl-6 pt-1">Admin Panel</h1>
                <div v-if="login" class="flex justify-content-end flex-wrap" style="max-width: 200px">
                    <div class="flex align-items-center" style="width: 150px">
                        <i class="pi pi-user mr-2"></i>
                        <span>{{ user_name }}</span>
                    </div>
                    <div class="flex align-items-center mt-2 cursor-pointer hover:text-primary" style="width: 150px" @click="admin_logout()">
                        <i class="pi pi-sign-out mr-2"></i>
                        <span>Ausloggen</span>
                    </div>
                </div>
            </div>
            <div v-if="!login" class="mt-6 p-10 fadein animation-duration-1000">
                <div class="w-full">
                    <div class="flex justify-content-center">
                        <img v-if="login_image" :src="login_image" width="400" />
                    </div>
                </div>
                <div class="w-full mt-4">
                    <div class="flex justify-content-center">
                        <h2 class="font-bold">Admin Login</h2>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <Dropdown v-model="country_code" :options="country_codes" optionLabel="code" optionValue="value" class="w-7rem mr-2" />
                            <label for="country_code">Land</label>
                        </FloatLabel>
                        <FloatLabel>
                            <InputMask id="mobile" v-model="mobile" mask="079 999 99 99" autoClear autofocus placeholder="079 123 45 67" class="w-9rem" />
                            <label for="mobile">Handy-Nr</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="!token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="mobile.length != 13" label="Login" icon="pi pi-mobile" rounded @click="admin_login()" class="mt-2" />
                    </div>
                </div>
                <div v-if="token_login" class="w-full mt-6">
                    <div class="flex justify-content-center">
                        <FloatLabel>
                            <InputMask id="sms_token" v-model="sms_token" mask="9999" autoClear autofocus placeholder="1234" class="w-8rem" />
                            <label for="sms_token">SMS-Code</label>
                        </FloatLabel>
                    </div>
                </div>
                <div v-if="token_login" class="w-full">
                    <div class="mt-4 flex justify-content-center">
                        <Button :disabled="sms_token.length != 4" label="Login" icon="pi pi-sign-in" rounded @click="verify_sms_token()" class="mt-2" />
                    </div>
                </div>
            </div>

            <div v-if="login" class="mb-5">
                <div v-if="!loader">
                    <div class="mt-3">
                        <TabView class="col-12" ref="tabview4" v-model:activeIndex="activeTabIndex">
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-briefcase mr-2"></i>
                                    <span class="mr-2">Stellenausschreibungen</span>
                                    <Badge :value="jobs.length" severity="secondary" />
                                </template>
                                <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
                                    <Toolbar>
                                        <template #start>
                                            <span class="p-input-icon-left mr-2">
                                                <i class="pi pi-search" />
                                                <InputText v-model="filter_jobs['global'].value" placeholder="Suche" style="width: 400px" class="mr-2" />
                                            </span>
                                        </template>
                                    </Toolbar>
                                    <DataTable v-model:filters="filter_jobs" :value="jobs" :rowHover="true" :paginator="true" :rows="50" :rowsPerPageOptions="[50, 100, 200]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                                        <Column field="job_title" header="Stelle" sortable>
                                            <template #body="slotProps">
                                                <i class="pi pi-briefcase mr-2 text-primary"></i><span class="font-bold">{{ slotProps.data.job_title }}</span>
                                            </template>
                                        </Column>
                                        <Column field="job_runtime_start" header="Start" sortable>
                                            <template #body="slotProps">
                                                <span>{{ swiss_date(slotProps.data.job_runtime_start) }}</span>
                                            </template>
                                        </Column>
                                        <Column field="job_runtime_end" header="Ende" sortable>
                                            <template #body="slotProps">
                                                <span>{{ swiss_date(slotProps.data.job_runtime_end) }}</span>
                                            </template>
                                        </Column>
                                        <Column field="job_status" header="Status" sortable>
                                            <template #body="slotProps">
                                                <Chip v-if="slotProps.data.job_status == 'active'" class="bg-green-100 text-black-alpha-90" label="Aktiv" />
                                                <Chip v-if="slotProps.data.job_status == 'inactive'" class="bg-red-100 text-black-alpha-90" label="Inaktiv" />
                                            </template>
                                        </Column>
                                        <Column>
                                            <template #body="slotProps">
                                                <Button icon="pi pi-pencil" class="p-button-rounded p-button-text" v-tooltip.top="'Job bearbeiten'" @click="edit_job(slotProps.data)" />
                                                <Button icon="pi pi-megaphone" class="p-button-rounded p-button-text" v-tooltip.top="'Marketinganweisungen'" @click="edit_job_marketing(slotProps.data)" />
                                                <Button icon="pi pi-eye" class="p-button-rounded p-button-text" v-tooltip.top="'Bewerbungen ansehen'" @click="open_url('https://www.snappy.jobs/migrosbank/'+String(slotProps.data.job_id)+'/' + slotProps.data.slug)" />
                                                <Button icon="pi pi-chart-line" class="p-button-rounded p-button-text mr-2" v-tooltip.top="'Statistik'" />
                                                <Button icon="pi pi-trash" class="p-button-rounded p-button-text text-red-500" v-tooltip.top="'Stelle löschen'" @click="delete_job(slotProps.data)" />
                                            </template>
                                            <template #header>
                                                <Button icon="pi pi-plus" class="p-button-rounded" v-tooltip.top="'Stelle erstellen'" @click="create_job()" />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <template #header>
                                    <i class="pi pi-pen-to-square mr-2"></i>
                                    <span class="mr-2">Bewerbungen</span>
                                    <Badge :value="candidates.length" severity="secondary" />
                                </template>
                                <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
                                    <Toolbar>
                                        <template #start>
                                            <span class="p-input-icon-left mr-2">
                                                <i class="pi pi-search" />
                                                <InputText v-model="filter_candidates['global'].value" placeholder="Suche" style="width: 400px" class="mr-2" />
                                            </span>
                                        </template>
                                    </Toolbar>
                                    <DataTable v-model:filters="filter_candidates" :value="candidates" @row-click="view_candidate" :rowHover="true" :paginator="true" :rows="50" :rowsPerPageOptions="[50,100,200]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                                        <Column field="source.job_title" hidden />
                                        <Column field="source.job_contact_name" hidden />
                                        <Column field="form.firstName" hidden />
                                        <Column field="form.lastName" hidden />
                                        <Column field="form.telephone" hidden />
                                        <Column field="form.email" hidden />
                                        <Column header="Name" sortable>
                                            <template #body="slotProps">
                                                <i class="pi pi-pen-to-square mr-2 text-primary"></i><span class="font-bold">{{ slotProps.data.form.firstName }} {{ slotProps.data.form.lastName }}</span>
                                            </template>
                                        </Column>
                                        <Column header="Handy-Nr" sortable hidden>
                                            <template #body="slotProps">
                                                <span>{{ slotProps.data.form.telephone }}</span>
                                            </template>
                                        </Column>
                                        <Column header="Email" sortable hidden>
                                            <template #body="slotProps">
                                                <span>{{ slotProps.data.form.email }}</span>
                                            </template>
                                        </Column>
                                        <Column field="dc" header="Erstellt am" sortable>
                                            <template #body="slotProps">
                                                <span>{{ swiss_date_time(slotProps.data.dc) }}</span>
                                            </template>
                                        </Column>
                                        <Column header="Stelle" sortable>
                                            <template #body="slotProps">
                                                <span class="font-bold">{{ slotProps.data.source.job_title }}</span>
                                            </template>
                                        </Column>
                                        <Column header="Kontaktperson" sortable>
                                            <template #body="slotProps">
                                                <Chip :label="slotProps.data.source.job_contact_name" class="bg-primary" />
                                            </template>
                                        </Column>
                                        <Column field="status" header="Status" sortable>
                                            <template #body="slotProps">
                                                <Chip icon="pi pi-clock" v-if="slotProps.data.status == 'Follow-Up'" :label="slotProps.data.status" />
                                                <Chip icon="pi pi-exclamation-triangle" v-if="slotProps.data.status == 'CV Vorhanden'" style="background: #f59e0b" class="text-alpha-90" :label="slotProps.data.status" />
                                                <Chip icon="pi pi-times" v-if="slotProps.data.status == 'Absage'" style="background: #ef4444" class="text-white" :label="slotProps.data.status" />
                                            </template>
                                        </Column>
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel v-if="user_role == 'Admin'">
                                <template #header>
                                    <i class="pi pi-align-left mr-2"></i>
                                    <span class="mr-3">Vorlagetexte</span>
                                    <Badge :value="templates.length" severity="secondary" />
                                </template>
                                <div rounded class="overflow-hidden shadow-3 border-200 mt-4">
                                    <Toolbar>
                                        <template #start>
                                            <span class="p-input-icon-left mr-2">
                                                <i class="pi pi-search" />
                                                <InputText v-model="filter_templates['global'].value" placeholder="Suche" style="width: 400px" class="mr-2" />
                                            </span>
                                            <Button :disabled="template_edits == 0" label="Vorlage speichern" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="save_templates()" :badge="String(template_edits)" badgeSeverity="contrast" />
                                        </template>
                                        <template #end>
                                            <Button icon="pi pi-plus" class="p-button-rounded" @click="create_template()" v-tooltip.top="'Neue Vorlage erstellen'" />
                                        </template>
                                    </Toolbar>
                                    <DataTable v-model:filters="filter_templates"  :value="templates" :rowHover="true" class="w-full">
                                        <Column header="Vorlage" sortable style="width: 300px">
                                            <template #body="slotProps">
                                                <div class="font-bold">
                                                    {{ slotProps.data.name }}
                                                </div>
                                                <div class="text-sm text-gray-500">
                                                    ID: {{ slotProps.data.id }} <i class="pi pi-copy cursor-pointer text-secondary" @click="copy_to_clipboard(slotProps.data.id)"></i>
                                                </div>
                                                <div>
                                                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-text" @click="edit_template(slotProps)" v-tooltip.top="''" />
                                                    <Button :disabled="template_edits > 0" icon="pi pi-envelope" class="p-button-rounded p-button-text" @click="send_test_email_input(slotProps)" />
                                                    <Button icon="pi pi-trash" class="p-button-rounded p-button-text text-red-500" @click="delete_template(slotProps)" />
                                                </div>
                                            </template>
                                        </Column>
                                        <Column header="Vorschau">
                                            <template #body="slotProps">
                                                <div class="w-full border-blue-100 border-solid border-bottom-1 m-0 p-2">
                                                    <span class="font-bold mr-2">BETREFF:</span>
                                                    <span class="text-gray-500">{{ slotProps.data.subject }}</span>
                                                </div>
                                                <div class="w-full mt-2 p-2" v-html="slotProps.data.content"></div>
                                            </template>
                                        </Column>
                                        <Column field="id" hidden />
                                        <Column field="name" hidden />
                                        <Column field="subject" hidden />
                                        <Column field="content" hidden />
                                    </DataTable>
                                </div>
                            </TabPanel>
                            <TabPanel v-if="user_role == 'Admin'">
                                <template #header>
                                    <i class="pi pi-lock mr-2"></i>
                                    <span class="mr-2">Benutzer</span>
                                    <Badge :value="users.length" severity="secondary" />
                                </template>
                                <Toolbar>
                                    <template #start>
                                        <span class="p-input-icon-left mr-2">
                                            <i class="pi pi-search" />
                                            <InputText v-model="filter_users['global'].value" placeholder="Suche" style="width: 400px" class="mr-2" />
                                        </span>
                                    </template>
                                </Toolbar>
                                <DataTable v-model:filters="filter_users" v-model:editingRows="edit_users" editMode="row" dataKey="mobile" @row-edit-save="on_row_user_save" :value="users" :rowHover="true" :paginator="true" :rows="20" :rowsPerPageOptions="[20,50,100]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                                    <Column field="name" header="Name" sortable>
                                        <template #body="slotProps">
                                            <i class="pi pi-user mr-2 text-primary"></i><span class="font-bold">{{ slotProps.data.name }}</span>
                                        </template>
                                        <template #editor="slotProps">
                                            <InputText v-model="slotProps.data.name" class="w-full" />
                                        </template>
                                    </Column>
                                    <Column field="mobile" header="Handy-Nr" sortable>
                                        <template #body="slotProps">
                                            <span>{{ slotProps.data.mobile }}</span>
                                        </template>
                                        <template #editor="slotProps">
                                            <InputMask v-model="slotProps.data.mobile" mask="+41 79 999 99 99" autoClear autofocus placeholder="+41 79 123 45 67" class="w-9rem" />
                                        </template>
                                    </Column>
                                    <Column field="email" header="E-Mail" sortable>
                                        <template #body="slotProps">
                                            <span>{{ slotProps.data.email }}</span>
                                        </template>
                                        <template #editor="slotProps">
                                            <InputText v-model="slotProps.data.email" class="w-full" />
                                        </template>
                                    </Column>
                                    <Column field="role" header="Rolle" sortable>
                                        <template #body="slotProps">
                                            <Chip :label="slotProps.data.role" />
                                        </template>
                                        <template #editor="slotProps">
                                            <Dropdown v-model="slotProps.data.role" :options="roles" optionLabel="label" optionValue="value" class="w-full" />
                                        </template>
                                    </Column>
                                    <Column field="id" hidden />
                                    <Column :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
                                        <template #header>
                                            <Button icon="pi pi-plus" class="mr-2 p-button-rounded" v-tooltip.top="'Benutzer hinzufügen'" @click="create_user_dialog = true" />
                                        </template>
                                    </Column>
                                </DataTable>
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>
            <div class="w-full">
                <div class="flex justify-content-center">
                    <div class="mt-6">
                        <span class="text-gray-500">©2025 <span class="font-bold hover:text-primary cursor-pointer" @click="open_url('https://www.snappy.works')">Snappy GmbH</span>. All rights reserved.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <!-------------------------------- Sidebar: Sources ----------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <Sidebar header="Job bearbeiten" v-model:visible="edit_job_slider" position="right" style="width: 80%">
        <div class="grid">
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Job Titel
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_title" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Kurzbeschreibung
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Textarea v-model="job.short_description" rows="5" class="w-full" autoResize  />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                PLZ
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.postal_code" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Ort
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.city" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Job Typ
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Dropdown v-model="job.job_type" :options="job_types" optionLabel="label" optionValue="value" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Kapazität
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_capacity" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Was du bewegst
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <DataTable :value="job.job_description" editMode="cell" @cell-edit-complete="edit_job_description_save" :rowHover="true" :paginator="true" :rows="20" :rowsPerPageOptions="[20,50,100]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                    <Column field="type" header="Typ" sortable>
                        <template #body="slotProps">
                            <span class="font-bold">{{ get_job_description_type(slotProps.data.type) }}</span>
                        </template>
                        <template #editor="slotProps">
                            <Dropdown v-model="slotProps.data.type" :options="job_description_types" optionLabel="label" optionValue="value" class="w-full" />
                        </template>
                    </Column>
                    <Column field="description" header="Beschreibung" sortable>
                        <template #body="slotProps">
                            <span>{{ slotProps.data.description }}</span>
                        </template>
                        <template #editor="slotProps">
                            <InputText v-model="slotProps.data.description" class="w-full" />
                        </template>
                    </Column>
                    <Column style="width: 10%; min-width: 8rem">
                        <template #header>
                            <Button icon="pi pi-plus" class="p-button-rounded" v-tooltip.top="'Beschreibung hinzufügen'" @click="job.job_description.push({type: null, description: ''})" />
                        </template>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-text text-red-500" v-tooltip.top="'Beschreibung löschen'" @click="delete_job_description(slotProps)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Was du mitbringst
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <DataTable :value="job.job_requirements" editMode="cell" @cell-edit-complete="edit_job_requirements_save" :rowHover="true" :paginator="true" :rows="20" :rowsPerPageOptions="[20,50,100]" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" currentPageReportTemplate="{first} bis {last} von {totalRecords}">
                    <Column field="type" header="Typ" sortable>
                        <template #body="slotProps">
                            <span class="font-bold">{{ get_job_description_type(slotProps.data.type) }}</span>
                        </template>
                        <template #editor="slotProps">
                            <Dropdown v-model="slotProps.data.type" :options="job_description_types" optionLabel="label" optionValue="value" class="w-full" />
                        </template>
                    </Column>
                    <Column field="description" header="Beschreibung" sortable>
                        <template #body="slotProps">
                            <span>{{ slotProps.data.description }}</span>
                        </template>
                        <template #editor="slotProps">
                            <InputText v-model="slotProps.data.description" class="w-full" />
                        </template>
                    </Column>
                    <Column style="width: 10%; min-width: 8rem">
                        <template #header>
                            <Button icon="pi pi-plus" class="p-button-rounded" v-tooltip.top="'Beschreibung hinzufügen'" @click="job.job_requirements.push({type: null, description: ''})" />
                        </template>
                        <template #body="slotProps">
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-text text-red-500" v-tooltip.top="'Beschreibung löschen'" @click="delete_job_requirements(slotProps)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Kontaktperson
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_contact_name" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Kontakt Email
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_contact_email" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Kontakt Rollenbezeichnung
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_contact_role" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Job URL (Link)
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="job.job_url" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Laufzeit (Start/Ende)
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Calendar v-model="job.job_runtime_start" class="w-auto mr-2" showIcon dateFormat="dd.mm.yy" />
                <Calendar v-model="job.job_runtime_end" class="w-auto" showIcon dateFormat="dd.mm.yy" />
            </div>
            <div class="col-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Status
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Dropdown v-model="job.job_status" :options="job_statuses" optionLabel="label" optionValue="value" class="w-full" />
            </div>
            <div class="col-10 p-2 pt-4 border-blue-100 border-solid border-bottom-1 m-0">
                <Button label="Job speichern" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="save_job()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_job_slider = false" />
            </div>
            <div class="col-2 p-2 pt-4 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button label="Job löschen" icon="pi pi-trash" class="p-button-danger w-auto" @click="delete_job()" />
            </div>
        </div>
    </Sidebar>
    <Sidebar header="Marketinganweisungen" v-model:visible="edit_job_marketing_slider" position="right" style="width: 80%">
        <div class="grid">
            <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Job Titel
            </div>
            <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <span class="font-bold">{{ job.job_title }}</span>
            </div>
            <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Allgemeine Anweisungen
            </div>
            <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Textarea v-model="job.job_marketing_general" class="w-full" />
            </div>
            <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Anweisungen für Zielorte
            </div>
            <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Textarea v-model="job.job_marketing_target_locations" class="w-full" />
            </div>
            <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Anweisungen für Zielgruppen
            </div>
            <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Textarea v-model="job.job_marketing_target_audience" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button label="Anweisungen speichern" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="save_job()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_job_marketing_slider = false" />
            </div>
        </div>
    </Sidebar>
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <!-------------------------------- Sidebar: Candidate ------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <Sidebar header="Bewerbung" v-model:visible="view_candidate_slider" position="left" style="width: 95%">
        <div class="grid">
            <div class="col-6">
                <div class="grid">
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Erstellt am
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span>{{ swiss_date_time(candidate.dc) }}</span>
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Bewerbung PDF
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Button v-if="candidate.cv_url" label="CV PDF ansehen" icon="pi pi-file-pdf" class="p-button-primary w-auto" @click="open_pdf(candidate.cv_url)" />
                        <Button v-else label="Kein CV PDF vorhanden" icon="pi pi-file-pdf" class="p-button-secondary w-auto" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Vorname
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <InputText v-model="candidate.form.firstName" class="w-full" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Nachname
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <InputText v-model="candidate.form.lastName" class="w-full" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Telefon-Nr
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <InputText v-model="candidate.form.telephone" class="w-full" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Email-Adresse
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <InputText v-model="candidate.form.email" class="w-full" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Aktuell in Anstellung?
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Dropdown v-model="candidate.form.employment" :options="yes_no" optionLabel="label" optionValue="value" class="w-full" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Status
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <Chip v-if="candidate.status == 'Follow-Up'" :label="candidate.status" />
                        <Chip v-if="candidate.status == 'CV Vorhanden'" style="background: #f59e0b" class="text-alpha-90" :label="candidate.status" />
                        <Chip v-if="candidate.status == 'Absage'" style="background: #ef4444" class="text-white" :label="candidate.status" />
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        Nachricht
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <span>{{ candidate.form.message }}</span>
                    </div>
                    <div class="col-4 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                        LinkedIn oder Xing Profil URL
                    </div>
                    <div class="col-8 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                        <a class="font-bold text-primary" :href="candidate.form.profileUrl" target="_blank">{{ candidate.form.profileUrl }}</a>
                    </div>
                    <div class="col-12 p-2 pt-4 border-blue-100 border-solid border-bottom-1 m-0">
                        <div class="surface-card p-4 shadow-3 border-round">
                            <div v-if="!candidate_flow && candidate.status != 'Absage'" class="font-bold text-xl flex justify-content-center mt-2">Ist dieser Kandidat interessant?</div>
                            <div v-if="!candidate_flow && candidate.status != 'Absage'" class="flex justify-content-center mt-3">
                                <Button label="Ja" icon="pi pi-check" class="p-button-success w-auto mr-2" />
                                <Button label="Unklar" icon="pi pi-question" class="p-button-warning w-auto mr-2" />
                                <Button label="Nein" icon="pi pi-times" class="p-button-danger w-auto" @click="candidate_flow = 'not_interesting'" />
                            </div>
                            <div v-if="candidate_flow == 'not_interesting' && candidate.status != 'Absage'" class="font-bold text-xl flex justify-content-center mt-2">Kandidat ist nicht interessant, weiteres vorgehen:</div>
                            <div v-if="candidate_flow == 'not_interesting' && candidate.status != 'Absage'" class="flex justify-content-center mt-3">
                                <Button label="Absage E-Mail erstellen" icon="pi pi-pencil" class="p-button-danger w-auto" @click="send_candidate_email('not_interesting')" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="font-bold text-xl flex justify-content-center mt-4">Kommunikationsverlauf</div>
                    </div>
                    <div class="col-12 mt-3" v-if="candidate.absage1">
                        <div rounded class="overflow-hidden shadow-3 border-200">
                            <div class="grid p-3">
                                <div class="col-2">
                                    <span class="font-bold">Gesendet:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ swiss_date_time(candidate.absage1.timestamp) }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">An:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.absage1.receiver }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Betreff:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.absage1.subject }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Inhalt:</span>
                                </div>
                                <div class="col-10">
                                    <span v-html="candidate.absage1.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3" v-if="candidate.cv_upload_request">
                        <div rounded class="overflow-hidden shadow-3 border-200">
                            <div class="grid p-3">
                                <div class="col-2">
                                    <span class="font-bold">Gesendet:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ swiss_date_time(candidate.cv_upload_request.timestamp) }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">An:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.cv_upload_request.receiver }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Betreff:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.cv_upload_request.subject }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Inhalt:</span>
                                </div>
                                <div class="col-10">
                                    <span v-html="candidate.cv_upload_request.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3" v-if="candidate.follow_up_email">
                        <div rounded class="overflow-hidden shadow-3 border-200">
                            <div class="grid p-3">
                                <div class="col-2">
                                    <span class="font-bold">Gesendet:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ swiss_date_time(candidate.follow_up_email.timestamp) }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">An:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.follow_up_email.receiver }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Betreff:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.follow_up_email.subject }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Inhalt:</span>
                                </div>
                                <div class="col-10">
                                    <span v-html="candidate.follow_up_email.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mt-3" v-if="candidate.last_reminder_email">
                        <div rounded class="overflow-hidden shadow-3 border-200">
                            <div class="grid p-3">
                                <div class="col-2">
                                    <span class="font-bold">Gesendet:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ swiss_date_time(candidate.last_reminder_email.timestamp) }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">An:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.last_reminder_email.receiver }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Betreff:</span>
                                </div>
                                <div class="col-10">
                                    <span>{{ candidate.last_reminder_email.subject }}</span>
                                </div>
                                <div class="col-2">
                                    <span class="font-bold">Inhalt:</span>
                                </div>
                                <div class="col-10">
                                    <span v-html="candidate.last_reminder_email.content"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <iframe v-if="candidate.cv_url" id="pdf_viewer" :src="candidate.cv_url" width="100%" height="100%" frameborder="0"></iframe>
                <div v-else class="flex justify-content-center align-items-center h-full">
                    <span class="text-gray-500">Kein PDF vorhanden</span>
                </div>
            </div>
        </div>
    </Sidebar>
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <!---------------------------- Sidebar: PDF iFrame viewer ----------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <Sidebar v-model:visible="pdf_viewer" position="right" style="width: 80%">
        <iframe id="pdf_viewer" :src="pdf_url" width="100%" height="100%" frameborder="0"></iframe>
    </Sidebar>
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------ Dialog: Create new job ------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <Dialog v-model:visible="create_job_dialog" header="Neue Stellenausschreibung" :style="{width: '1200px'}" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Job Titel
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="new_job.job_title" class="w-full" />
            </div>
            <div class="col-12 p-2 border-blue-100 border-solid border-bottom-1 m-0 border-blue-100 font-bold">
                oder
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Job URL (Link zur Stelle)
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="new_job.job_url" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button label="Stelle erstellen" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="save_new_job()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="create_job_slider = false" />
            </div>
        </div>
    </Dialog>
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------- Dialog: Create new user ------------------------------->
    <!------------------------------------------------------------------------------------->
    <!------------------------------------------------------------------------------------->
    <Dialog v-model:visible="create_user_dialog" header="Neuen Benutzer anlegen" :style="{width: '600px'}" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Name
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="new_user.name" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Handy-Nr
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputMask v-model="new_user.mobile" mask="+41 79 999 99 99" autoClear placeholder="+41 79 123 45 67" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Email
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="new_user.email" class="w-full" />
            </div>
            <div class="col-2 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0 flex align-items-center">
                Rolle
            </div>
            <div class="col-10 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Dropdown v-model="new_user.role" :options="roles" optionLabel="label" optionValue="value" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button :disabled="new_user.name == '' || new_user.mobile == '' || new_user.email == '' || new_user.role == ''" label="Benutzer erstellen" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="create_user(new_user)" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="create_user_dialog = false" />
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="edit_template_dialog" header="Vorlage bearbeiten" :style="{width: '80%'}" :modal="true" class="p-fluid z-5">
        <div class="grid">
            <div class="col-3 p-2 border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <div class="font-bold">
                    Vorlage Variablen
                </div>
                <div class="text-sm text-gray-500">
                    Variablen können in den Vorlagen verwendet werden
                </div>
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{candidate_firstname}')">
                    <span class="font-bold mr-2">{candidate_firstname}</span>
                    <span class="mr-2">Bewerber Vorname</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{candidate_lastname}')">
                    <span class="font-bold mr-2">{candidate_lastname}</span>
                    <span class="mr-2">Bewerber Nachname</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{job_title}')">
                    <span class="font-bold mr-2">{job_title}</span>
                    <span class="mr-2">Stellenbezeichnung</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{job_url}')">
                    <span class="font-bold mr-2">{job_url}</span>
                    <span class="mr-2">Stellenlink</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{job_contact_name}')">
                    <span class="font-bold mr-2">{job_contact_name}</span>
                    <span class="mr-2">Kontaktperson</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{job_contact_email}')">
                    <span class="font-bold mr-2">{job_contact_email}</span>
                    <span class="mr-2">Kontaktemail</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{job_contact_role}')">
                    <span class="font-bold mr-2">{job_contact_role}</span>
                    <span class="mr-2">Kontaktrolle</span>
                    <i class="pi pi-copy" />
                </Chip>
                <Chip class="mb-1 py-2 pl-3 pr-3 bg-primary hover:bg-primary-reverse cursor-pointer mr-2" @click="copy_to_clipboard('{cv_upload_link}')">
                    <span class="font-bold mr-2">{cv_upload_link}</span>
                    <span class="mr-2">CV Upload Link</span>
                    <i class="pi pi-copy" />
                </Chip>
            </div>
            <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Vorlage-Namen
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="template.name" class="w-full" />
            </div>
            <div class="col-3 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Vorlage-ID
            </div>
            <div class="col-9 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="template.id" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Betreff
            </div>
            <div class="col-12 p-2 border-blue-100 border-solid border-bottom-1 m-0">
                <InputText v-model="template.subject" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                Inhalt
            </div>
            <div class="col-12 p2 border-blue-100 border-solid border-bottom-1 m-0">
                <TabView>
                    <TabPanel>
                        <template #header>
                            <span class="mr-2">HTML</span>
                        </template>
                        <Textarea v-model="template.content" rows="10" class="w-full" autoResize />
                    </TabPanel>
                </TabView>
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button label="Vorlage speichern" icon="pi pi-save" class="p-button-success w-auto mr-2" @click="save_template()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="edit_template_dialog = false" />
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="test_email_dialog" header="Vorlage bearbeiten" :style="{width: '600px'}" :modal="true" class="p-fluid z-5">
        <div class="grid mt-4">
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <InputText v-model="test_email" class="w-full" />
            </div>
            <div class="col-12 p-2 font-bold border-blue-100 border-solid border-bottom-1 bg-blue-50 m-0">
                <Button label="Test-Mail senden" icon="pi pi-envelope" class="p-button-success w-auto mr-2" @click="send_test_email()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="test_email_dialog = false" />
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="dialog_send_candidate_email" header="Kandidat E-Mail senden" :style="{width: '800px'}" :modal="true" class="p-fluid z-5">
        <div class="grid mt-4">
            <div class="col-12">
                <InputText v-model="candidate_email_subject" class="w-full" />
            </div>
            <div class="col-12">
                <Textarea v-if="!email_preview" v-model="candidate_email_content" rows="10" class="w-full" autoResize />
                <div class="w-full p-2 border-gray-500 border-solid border-1 overflow-hidden" rounded v-if="email_preview">
                    <span v-html="candidate_email_content" class="text-sm text-gray-500"></span>
                </div>
                <div class="mt-2">
                    <span v-if="!email_preview" class="cursor-pointer text-primary font-medium hover:text-secondary" @click="email_preview = true"><i class="pi pi-pencil mr-2" />Vorschau</span>
                    <span v-if="email_preview" class="cursor-pointer text-primary font-medium hover:text-secondary" @click="email_preview = false"><i class="pi pi-eye mr-2" />Bearbeiten</span>
                </div>
            </div>
            <div class="col-12">
                <Button label="E-Mail senden" icon="pi pi-envelope" class="p-button-success w-auto mr-2" @click="send_candidate_email_with_template()" />
                <Button label="Abbrechen" icon="pi pi-times" class="p-button-danger w-auto" @click="dialog_send_candidate_email = false" />
            </div>
        </div>
    </Dialog>
</template>